import { Table } from 'antd';
import { FilterIcon } from 'components/Filters/FilterIcon';
import { RangePickerFilter } from 'components/Filters/RangePickerFilter';
import { SumRange } from 'components/Filters/SumRange';
import {
  COLUMN_EXTRA_SMALL,
  COLUMN_MEDIUM,
  COLUMN_SMALL,
  PAGE_SIZE_OPTIONS,
  SCROLL_Y,
} from 'constants/table';
import { checkValue } from 'utils';
import { priceRender, renderWithTooltip } from 'utils/table';

export const turnsTypeMap = {
  cash: 'Наличные',
  cashless: 'Безналичные',
  accruals: 'Начисления',
};

function BankStatementsTable({
  items,
  loading,
  current,
  pageSize,
  totalRows,
  filters = {},
  onRowClick,
  onFilter,
  onChange,
  isImport = false,
}) {
  const { f_sum, t_sum, start_date, end_date } = filters;

  const columns = [
    {
      width: COLUMN_EXTRA_SMALL,
      title: '№',
      dataIndex: 'numDocument',
      key: 'numDocument',
      render: checkValue,
    },
    {
      width: COLUMN_MEDIUM,
      title: 'Дата операции',
      dataIndex: 'dateOperation',
      key: 'dateOperation',
      filterDropdown: () => {
        return (
          <RangePickerFilter
            value={[start_date, end_date]}
            onFilterChange={([start, end]) => {
              onFilter({
                start_date: start,
                end_date: end,
              });
            }}
          />
        );
      },
      filterIcon: () => <FilterIcon isActive={start_date && end_date} />,
    },

    {
      width: COLUMN_MEDIUM,
      title: 'Вид операции',
      dataIndex: 'bank_operations',
      key: 'bank_operations',
      render: checkValue,
    },
    {
      width: COLUMN_MEDIUM,
      title: 'Контрагент',
      dataIndex: 'beneficiaryName',
      key: 'beneficiaryName',
      render: (name) => renderWithTooltip(name, 30),
    },
    {
      width: COLUMN_MEDIUM,
      title: 'Сумма',
      dataIndex: 'amount',
      key: 'amount',
      render: (sum, i) =>
        sum ? (
          <div style={{ color: '#52C41A' }}>{`+${priceRender(+sum)}`}</div>
        ) : (
          <div style={{ color: '#FF4D4F' }}>{`-${priceRender(
            +i.amountExpense
          )}`}</div>
        ),
      filterDropdown: () => {
        return (
          <SumRange
            fromValue={f_sum}
            toValue={t_sum}
            getRange={(first, second) =>
              onFilter({ f_sum: first, t_sum: second })
            }
          />
        );
      },
      filterIcon: () => <FilterIcon isActive={f_sum || t_sum} />,
    },
    {
      width: COLUMN_EXTRA_SMALL,
      title: 'КНП',
      dataIndex: 'knp_code',
      key: 'knp_code',
      render: checkValue,
    },
    {
      width: COLUMN_SMALL,
      title: 'Номер договора',
      dataIndex: 'number_contract',
      key: 'number_contract',
      render: checkValue,
    },
    {
      width: COLUMN_SMALL,
      title: 'Дата договора',
      dataIndex: 'date_contract',
      key: 'date_contract',
      render: checkValue,
    },
    {
      width: COLUMN_MEDIUM,
      title: 'БИН/ИИН контргаента',
      dataIndex: 'companyTin',
      key: 'companyTin',
      render: checkValue,
    },
    !isImport
      ? {
          width: COLUMN_MEDIUM,
          title: 'Клиент',
          dataIndex: 'companyName',
          key: 'companyName',
          render: (name) => renderWithTooltip(name, 60),
        }
      : {
          width: '0',
        },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ y: SCROLL_Y, x: !isImport ? 1300 : 1200 }}
      pagination={{
        current,
        total: totalRows,
        pageSize,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { BankStatementsTable };
